import React from 'react'
import BoxRojo from '../general/box-rojo'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const Container = styled.div`
  background-image: url(${props =>
    props.contentful
      ? `${props.imagen}?w=737&h=400&fit=fill&f=faces`
      : props.imagen});
  display: flex;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: 100% auto;
  padding-top: 200px;

  ${breakpoint('tablet')`
    background-image: url(${props =>
      props.contentful ? `${props.imagen}?w=1025` : props.imagen});
    flex-direction: row;
    justify-content: center;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
    padding: 40px 0;
  `}

  h1 {
    font-size: 25px;

    big {
      display: block;
      font-size: 45px;
    }
  }
`

const Wrapper = styled.div`
  width: 1000px;
  max-width: 100%;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;

    & > div {
      width: 50%;
      flex: none;
    }
  `}

  ${breakpoint('tablet')`
    & > div {
      width: 33.333%;
      flex: none;
    }
  `}
`

export default ({ children, imagen, contentful }) => {
  return (
    <Container imagen={imagen} contentful={contentful}>
      <Wrapper>
        <BoxRojo>{children}</BoxRojo>
      </Wrapper>
    </Container>
  )
}
